import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { BrowserStorageHelper } from '@core/helpers';

@Component({
    selector: 'app-menu-profile[closePopover][isSwitchGroupDisplayed][switchGroupDisplayChange]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
})
export class MenuProfileComponent {
    @Input() isSwitchGroupDisplayed: boolean = false;
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();
    @Output() switchGroupDisplayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private auth0: AuthService) { }

    close(): void {
        this.switchGroupDisplayChange.emit(false);
        this.closePopover.emit();
    }

    toggleMenuGroupOverlay(value: boolean): void {
        this.switchGroupDisplayChange.emit(value);

        // necessary for accessibility
        if (value) {
            setTimeout(() => {
                document.getElementById('app-menu-group-header')?.focus();
            }, 100);
        }
        if (!value) {
            setTimeout(() => {
                document.getElementById('user-group')?.focus();
            }, 100);
        }
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;
        BrowserStorageHelper.killSession();

        await this.auth0.logout({
            openUrl(_url) {
                window.location.replace(url);
            },
        });
    }
}
